import { FunctionComponent } from 'react';
import { FPMainModal } from 'widgets/auth/forgotPassword/_MainModal';

export const ForgotPassword: FunctionComponent = () => {
	return <FPMainModal />;
};
